import { isIOS, isChrome } from 'react-device-detect';

export const useIsDeviceSupported = (): boolean => {
  return !(isIOS && isChrome);
};
